import { render } from "./Recipes-edit.vue?vue&type=template&id=7e9f02c3&scoped=true"
import script from "./Recipes-edit.vue?vue&type=script&lang=js"
export * from "./Recipes-edit.vue?vue&type=script&lang=js"

import "./Recipes-edit.vue?vue&type=style&index=0&id=7e9f02c3&lang=css"
import "./Recipes-edit.vue?vue&type=style&index=1&id=7e9f02c3&scoped=true&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e9f02c3"]])

export default __exports__